import styled from 'styled-components'
import theme from 'theme_'
import { H5 } from 'components/Typography'

export const StyledTemplatesContainer = styled.div`
  padding: 12px;
  @media ${theme.devices.tablet} {
    padding: 16px 40px;
  }
`

export const TemplatesSearchWrapper = styled.div`
  margin-bottom: 16px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
`

export const StyledTemplatesHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  @media ${theme.devices.tablet} {
    margin-bottom: 16px;
  }
`

export const StyledNoTemplates = styled(H5)`
  text-align: center;
  color: ${theme.colors.disabledGrey};
`
